/**
 * Registration form constants for Parent and Tutor registration modals
 * Contains dropdown lists, subject data, and form-related configurations
 * Education subjects imported from centralized @tutor/types package
 */

export const REGISTRATION_STEPS = ['Tuition Details', 'Subject & Duration', 'Location & Time', 'Budget'];

export const DAYS_OF_WEEK = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

/**
 * Time slot configurations for preferred teaching times
 */
export const TIME_SLOT_CONFIGS: Record<string, { label: string; startHour: number; endHour: number }> = {
  Morning: { label: 'Morning', startHour: 8, endHour: 11 },
  Afternoon: { label: 'Afternoon', startHour: 12, endHour: 16 },
  Evening: { label: 'Evening', startHour: 17, endHour: 20 },
};

/**
 * Hour range configurations for each time slot
 * Used for validating time picker selections
 */
export const HOUR_RANGES: Record<string, { min: number; max: number }> = {
  Morning: { min: 6, max: 11 },
  Afternoon: { min: 12, max: 16 },
  Evening: { min: 17, max: 23 },
};


/**
 * Common remarks/notes for tutoring requests
 */
export const COMMON_REMARKS = [
  'Studing UEC',
  'Focus on weak areas and fundamentals',
  'Build confidence and interest in subject',
];

/**
 * Tuition types
 */
export const TUITION_TYPES = [
  'Individual',
  'Group',
  'Online',
  'Hybrid',
];


